// Mirrors the CURRENCIES list in backend/models.py — keep both in sync if changed.
export const CURRENCIES = [
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'NGN', symbol: '₦', name: 'Nigerian Naira' },
  { code: 'ZAR', symbol: 'R', name: 'South African Rand' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham' },
  { code: 'KES', symbol: 'KSh', name: 'Kenyan Shilling' },
  { code: 'GHS', symbol: '₵', name: 'Ghanaian Cedi' },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc' },
  { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar' },
];

export const CURRENCY_SYMBOLS = CURRENCIES.reduce((acc, c) => { acc[c.code] = c.symbol; return acc; }, {});
const CURRENCY_LOCALES = {
  GBP: 'en-GB', USD: 'en-US', NGN: 'en-NG', CAD: 'en-CA', AUD: 'en-AU',
  INR: 'en-IN', ZAR: 'en-ZA', AED: 'en-AE', JPY: 'ja-JP',
};
const ZERO_DECIMAL_CURRENCIES = new Set([
  'BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA', 'PYG',
  'RWF', 'VND', 'VUV', 'XAF', 'XOF', 'XPF', 'UGX',
]);

// Defaults to GBP ("£") for records created before currency selection existed.
export const currencySymbol = (code) => CURRENCY_SYMBOLS[code] || '£';

export const formatMoney = (amount, code) => `${currencySymbol(code)}${Number(amount || 0).toLocaleString()}`;

export const formatCurrency = (amount, code) => {
  const currency = (code || 'GBP').toUpperCase();
  const digits = ZERO_DECIMAL_CURRENCIES.has(currency) ? 0 : 2;
  try {
    return new Intl.NumberFormat(CURRENCY_LOCALES[currency] || navigator.language || 'en', {
      style: 'currency',
      currency,
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    }).format(Number(amount || 0));
  } catch (e) {
    return `${currency} ${Number(amount || 0).toFixed(digits)}`;
  }
};
